import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WalletState } from './wallet.types';
import { Wallet } from '../../models/wallet';

const initialState: WalletState = {
  wallet: null,
  fetched: false,
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    walletUpdated: (state, action: PayloadAction<Wallet|null>) => {
      state.wallet = action.payload;
      state.fetched = true;
    },
    walletListenerError: (state, action: PayloadAction<string>) => {
    },
    resetWallet: (state) => {
      state.wallet = null;
      state.fetched = false;
    },
  }
});

export const {
  walletUpdated,
  walletListenerError,
  resetWallet,
} = walletSlice.actions;

export default walletSlice.reducer;
